<template>
  <div>
    <div
      class="row no-gutters justify-content-space-evenly align-items-center my-1"
    >
      <div
        class="col-3 col-lg-1 mx-lg-1 h-100 mb-2 d-flex justify-content-center align-items-center btn clickable-text"
        v-on:click="onHorseNameClicked('name')"
      >
        <img
          :src="jockeySilkPath"
          @error="getImage('hollywoodSilk', 'png')"
          class="jockey-silks"
        />
      </div>
      <div class="col-8 col-lg-3 horse-details-wrapper my-3">
        <div class="row no-gutters align-items-center">
          <div class="col-8 col-lg-10" v-on:click="onHorseNameClicked('name')">
            <div class="row align-items-center">
              <span
                v-if="!showHorseSaddleCloths"
                class="font-weight-bold font-italic horse-name horse-name-number btn px-0"
                >{{ runner.horse.number }}</span
              >
              <img
                v-if="showHorseSaddleCloths"
                :id="'saddleCloths' + runner.horse.number"
                :src="
                  getImage(
                    `saddle-cloths-${runner.horse.number}`,
                    'svg',
                    `saddleCloths${runner.horse.number}`,
                  )
                "
                class="saddle-cloths"
              />
              <span
                class="font-weight-bold font-italic horse-name btn text-left clickable-text"
                >{{ runner.horse.name }}</span
              >
            </div>
          </div>
          <div class="col-2">
            <span
              v-on:click="onHollywoodOddsClicked(runner.horse.desktopUrl)"
              v-if="runner.runnerStatus === 1"
              class="d-md-none badge badge-secondary clickable-item hollywood-odds px-3"
            >
              <sup>{{ runner.horse.hollywoodOdds.numerator }}</sup
              >&frasl;<sub>{{ runner.horse.hollywoodOdds.denominator }}</sub>
            </span>

            <span
              v-tooltip="
                this.isBettingAllowed && !this.timeHasRunOutForBetting
                  ? 'Bet on this horse'
                  : ''
              "
              v-on:click="shouldAllowBetting(hollywoodbetsURL)"
              v-if="runner.runnerStatus === 1"
              :class="
                this.isBettingAllowed && !this.timeHasRunOutForBetting
                  ? 'd-none d-md-block badge badge-secondary clickable-item hollywood-odds px-0'
                  : 'd-none d-md-block badge badge-secondary clickable-item hollywood-odds px-0 badge-disabled-betting'
              "
            >
              <sup>{{ runner.horse.hollywoodOdds.numerator }}</sup
              >&frasl;<sub>{{ runner.horse.hollywoodOdds.denominator }}</sub>
            </span>
            <span
              v-if="runner.runnerStatus === 2"
              class="badge badge-secondary scratched-runner"
              >SCR</span
            >
          </div>
        </div>
        <span class="row no-gutters font-italic horse-details">{{
          runner.horse.ageColourSex | dob
        }}</span>
        <span
          class="row no-gutters font-italic horse-details clickable-text"
          v-on:click="onBreederNameClicked('name')"
          >{{ runner.horse.breedingDetails }}</span
        >
        <span
          class="row no-gutters font-italic horse-details clickable-text"
          v-on:click="onBreederNameClicked('name')"
          >{{ runner.horse.breeder }}</span
        >
        <span
          class="row no-gutters font-italic horse-details font-weight-bold"
          >{{ runner.horse.owners | addspace }}</span
        >
        <span
          v-if="selectedRace.raceByRace.averageFieldMeritRating"
          class="row no-gutters font-italic horse-details font-weight-bold"
          >MR - {{ runner.horse.meritRating }}</span
        >
      </div>
      <div class="horse-race-details col-3 col-lg-1 text-center h-100">
        <div class="w-100">
          <table class="table">
            <tr>
              <td class="flex-nowrap">
                <span class="fraction">
                  <span class="numerator race-draw">{{
                    runner.horse.draw.numerator
                  }}</span>
                  <span class="denominator race-draw">{{
                    runner.horse.draw.denominator
                  }}</span>
                </span>
              </td>
              <td class="flex-nowrap num-circle-td">
                <div class="numberCircle">
                  <span class="text">{{ runner.horse.meritRating }}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td class="flex-nowrap d-flex align-items-center">
                <span
                  class="font-weight-bold d-flex justify-content-center w-100"
                >
                  <table>
                    <tbody class="jockey-weight-apprentice-claim">
                      <tr>
                        <td>{{ runner.jockey.weight }}</td>
                      </tr>
                      <tr>
                        <td class="jockey-apprentice-claim">
                          {{ runner.jockey.weightAllowance }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </td>
              <td class="flex-nowrap">
                <span style="white-space: nowrap" class="font-weight-bold">{{
                  runner.horse.equipment
                }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-8 col-lg-5 team-details align-items-center">
        <div
          class="row no-gutters mb-1 mb-lg-2 py-1 horse-career-wrapper align-items-center"
        >
          <div
            v-if="runner.runnerStatus === 1"
            class="col-6 btn clickable-text"
            v-on:click="onJockeyNameClicked('name')"
          >
            <span
              class="row d-flex no-gutters font-weight-bold jockey-trainer-name justify-content-center"
              >{{ runner.jockey.name | jockeyinit | init }}</span
            >
            <span
              class="row d-flex no-gutters jockey-trainer-career text-center justify-content-center"
              >{{ runner.jockey.career }}</span
            >
          </div>
          <div v-if="runner.runnerStatus === 2" class="col-6 text-center">
            <span
              class="font-weight-bold jockey-trainer-name-scratched justify-content-center py-1 px-2"
              >SCRATCHED</span
            >
          </div>
          <div
            class="col-6 align-items-center btn clickable-text"
            v-on:click="onTrainerNameClicked('name')"
          >
            <span
              class="row d-flex no-gutters font-weight-bold jockey-trainer-name justify-content-center"
              >{{ runner.trainer.name | init }}</span
            >
            <span
              class="row d-flex no-gutters jockey-trainer-career justify-content-center"
              >{{ runner.trainer.career }}</span
            >
          </div>
        </div>
        <div class="row no-gutters">
          <div
            class="col-12 horse-career-wrapper pr-1 pr-lg-4 d-flex justify-content-center"
          >
            <table>
              <tr>
                <td class="flex-nowrap font-weight-bold">Total Runs:</td>
                <td class="flex-nowrap">{{ runner.horse.career.totalRuns }}</td>
                <td class="flex-nowrap font-weight-bold">C:</td>
                <td class="flex-nowrap">{{ runner.horse.career.course }}</td>
                <td class="flex-nowrap font-weight-bold">P:</td>
                <td class="flex-nowrap">{{ runner.horse.career.poly }}</td>
              </tr>
              <tr>
                <td class="flex-nowrap font-weight-bold">Stakes:</td>
                <td class="flex-nowrap">
                  {{
                    runner.horse.career.stakes
                      | currency("R", 0, { thousandsSeparator: " " })
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">D:</td>
                <td class="flex-nowrap">{{ runner.horse.career.distance }}</td>
                <td class="flex-nowrap font-weight-bold">W:</td>
                <td class="flex-nowrap">{{ runner.horse.career.wet }}</td>
              </tr>
              <tr>
                <td class="flex-nowrap font-weight-bold">Sale Price:</td>
                <td class="flex-nowrap">
                  {{
                    runner.horse.career.salePrice
                      | currency("R", 0, { thousandsSeparator: " " })
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">C&D:</td>
                <td class="flex-nowrap">
                  {{ runner.horse.career.courseAndDistance }}
                </td>
                <td class="flex-nowrap font-weight-bold">S:</td>
                <td class="flex-nowrap">{{ runner.horse.career.sand }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters justify-content-space-evenly team-details-table">
      <div style="position: relative" class="col-12 px-2">
        <div id="team-details-table" class="table-responsive">
          <table class="table">
            <thead class="thead-dark">
              <tr>
                <th scope="col" v-on:click="onDateOrderingToggled()">
                  <img
                    v-bind:id="'date-ordering-icon-' + index"
                    class="toggle-arrow"
                    :src="getImage('arrow-white-down')"
                  />
                  DATE
                </th>
                <th scope="col">CRS</th>
                <th scope="col" class="d-none d-md-table-cell">REF</th>
                <th scope="col">RACE</th>
                <th scope="col">AR</th>
                <th scope="col">DIST</th>
                <th scope="col">DRW</th>
                <th scope="col">POS</th>
                <th scope="col">LTH</th>
                <th scope="col">WINNER/2nd</th>
                <th scope="col">JOCKEY</th>
                <th scope="col">WGT</th>
                <th scope="col">MR</th>
                <th scope="col">SH</th>
                <th scope="col">TIME</th>
                <th scope="col">ADJ/TM</th>
                <th scope="col">OB</th>
                <th scope="col">SP</th>
                <th scope="col">SPR</th>
                <th scope="col">COMMENT</th>
              </tr>
            </thead>
            <tbody v-if="visiblePreviousRaceResults.length > 0">
              <tr
                v-for="(raceResult, index) in visiblePreviousRaceResults"
                :key="index"
              >
                <td
                  scope="row"
                  v-bind:class="{ 'red-text': raceResult.longRestPeriod }"
                >
                  {{ raceResult.date | dateformat }}
                </td>
                <td class="highlighted-table-cell">{{ raceResult.course }}</td>
                <td class="d-none d-md-table-cell">
                  {{ raceResult.referenceAndGoing }}
                </td>
                <td>{{ raceResult.race }}</td>
                <td>{{ raceResult.averageFieldRating }}</td>
                <td>{{ raceResult.distance }}</td>
                <td>{{ raceResult.draw }}</td>
                <td>
                  <img
                    v-on:click="
                      openFormGrid(raceResult.id, raceResult.position)
                    "
                    :src="
                      getImage(
                        'wf-finishing-position-' + raceResult.position,
                        'svg',
                        'raceresult' + raceResult.position + raceResult.id,
                      )
                    "
                    class="finishing-position-icon"
                    :id="'raceresult' + raceResult.position + raceResult.id"
                  />
                </td>
                <td>{{ raceResult.lengths }}</td>
                <td
                  class="font-italic text-left clickable-text"
                  v-on:click="onHorseNameClicked('name')"
                >
                  {{ raceResult.winnerOrSecond }}
                </td>
                <td
                  class="highlighted-table-cell text-left clickable-text"
                  v-on:click="onJockeyNameClicked('name')"
                >
                  {{ raceResult.jockey | jockeyinit }}
                </td>
                <td class="font-weight-bold">
                  {{ raceResult.weight | wgtdecimalpoint }}
                </td>
                <td class="font-weight-bold">{{ raceResult.meritRating }}</td>
                <td>{{ raceResult.equipment }}</td>
                <td>{{ raceResult.time | timetocolon }}</td>
                <td>{{ raceResult.adjustedTime }}</td>
                <td>
                  <sup>{{ raceResult.openingPrice.numerator }}</sup
                  >&frasl;<sub>{{ raceResult.openingPrice.denominator }}</sub>
                </td>
                <td>
                  <sup>{{ raceResult.startingPrice.numerator }}</sup
                  >&frasl;<sub>{{ raceResult.startingPrice.denominator }}</sub>
                </td>
                <td>{{ raceResult.speedRating }}</td>
                <td class="highlighted-table-cell text-left">
                  {{ raceResult.comment }}
                </td>
              </tr>
              <tr>
                <td colspan="21" class="text-left">
                  {{ runner.horse.raceComment }}
                </td>
              </tr>
            </tbody>
            <tbody v-if="visiblePreviousRaceResults.length === 0">
              <tr>
                <td colspan="21" class="text-center">First run</td>
              </tr>
              <tr>
                <td colspan="21" class="text-center">
                  {{ runner.horse.raceComment }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="runner.horse.previousRaceResults.length > 7"
          class="row no-gutters d-flex justify-content-center"
        >
          <div
            class="extra-rows-toggle-button col-12 btn text-center"
            v-on:click="toggleExtraRaceResults()"
          >
            <img
              v-bind:id="'extra-rows-down-arrow-' + index"
              class="extra-rows-down-arrow"
              :src="getImage('fixtures-dropdown-icon')"
            />
          </div>
        </div>
        <finishing-position-pop-up
          :offsetLeft="offsetLeft"
          :offsetTop="offsetTop"
          :onPositionClickedCallback="onFormGridOpened"
          v-if="isFinishPositionPopupOpen"
        ></finishing-position-pop-up>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

import { JockeySilks } from "../components/configuration/jockeySilksMapping.constant";
import { JockeySilksDateMappings } from "./configuration/jockeySilksDateMappings";
import FinishingPositionPopUp from "./FinishingPositionPopUp";
import jockeyTrainer from "../components/mixins/Jockey-TrainerName";
import { convertSVGToBase64 } from "../services/ExportToPdf";
export default {
  name: "RaceCardTeamDetails",
  mixins: [jockeyTrainer],
  components: { FinishingPositionPopUp },
  props: {
    timeHasRunOutForBetting: Boolean,
    isBettingAllowed: Boolean,
    openFormGridCallback: Function,
    runner: Object,
    index: Number,
  },
  data: function () {
    return {
      jockeySilks: JockeySilks,
      displaySmallTable: false,
      isFinishPositionPopupOpen: false,
      isFormGridOpen: false,
      offsetLeft: 0,
      offsetTop: 0,
      scrollLeft: 0,
      visiblePreviousRaceResults: [],
      areRaceResultsExpanded: false,
      jockeySilkPath: "",
      showHorseSaddleCloths: false,
      hollywoodbetsMobileURL:
        "https://m.hollywoodbets.net/betting/8/horse-racing",
      hollywoodbetsURL:
        "https://www.hollywoodbets.net/betting/8/horse-racing-south-africa/all",
    };
  },
  filters: {
    timetocolon: function (value) {
      value = value.toString();
      if (value != null && value.includes(".")) {
        value = value.replace(".", ":");
        return value;
      } else {
        return value;
      }
    },

    addspace: function (value) {
      value = value.toString();
      if (value != null && !value.includes(" ")) {
        value = value.replaceAll(",", ", ");
        return value;
      } else {
        return value;
      }
    },
    dateformat: function (value) {
      value = value.toString();
      if (value != null && value.includes("(")) {
        value = value.replace(" ", "");
        value = value.replace(")", ") ");
      }
      return value;
    },

    wgtdecimalpoint: function (value) {
      value = value.toString();
      if (value != null && !value.includes(".")) {
        let val = value.split("kg");
        val = val + ".0kg";
        val = val.replace(",", "");
        return val.toString();
      } else if (value != null && value.includes(".")) {
        return value;
      }
    },
    dob: function (value) {
      value = value.toString();
      if (value != null && value.includes("dob")) {
        value = value.replace("dob", "Dob");
        return value;
      } else {
        return value;
      }
    },
  },
  computed: mapState([
    "selectedRaceCard",
    "selectedRace",
    "raceCardDateToggleAscending",
  ]),
  created() {
    this.setJockeySilkPath();
  },
  methods: {
    shouldAllowBetting(url) {
      if (this.isBettingAllowed && !this.timeHasRunOutForBetting) {
        this.onHollywoodOddsClicked(url);
      }
    },
    setJockeySilkPath() {
      const basePath =
          "https://winningform.blob.core.windows.net/jockey-silks/",
        courseName =
          this.jockeySilks[
            this.selectedRaceCard.raceCardSummary.raceTrackAssetId
          ].silkCourseName,
        dateSplit = this.selectedRace.raceByRace.date.split("-")[1].split(" "),
        dateNumber = dateSplit[1],
        dateMonth = JockeySilksDateMappings[dateSplit[2]],
        raceNumber = this.selectedRace.raceByRace.raceNumber,
        horseNumber = this.runner.horse.number,
        SAS =
          "?sp=r&st=2026-03-02T05:31:46Z&se=2027-12-31T13:46:46Z&spr=https&sv=2024-11-04&sr=c&sig=b9DBwuC35rGfppV9RGeDQuAa9Q%2FXTgzVqRAQ6N%2FZqos%3D",
        silkPath = `${basePath}${dateNumber}_${dateMonth}_${courseName}_${raceNumber}_${horseNumber}.jpg${SAS}`;

      this.jockeySilkPath = silkPath;
    },
    getImage(imagePath, fileType = "svg", element) {
      const image = require("../assets/images/" + imagePath + "." + fileType);

      if (element) {
        if (image.slice(-3) === "svg") {
          convertSVGToBase64(element, image);
        }
      } else {
        return require("../assets/images/" + imagePath + "." + fileType);
      }
    },
    setTableState() {
      if (window.innerWidth < 1200) this.displaySmallTable = true;
    },
    onPageClicked(evt) {
      const finishingPositionIcon = document.querySelector(
        ".finishing-position-icon",
      );
      let targetElement = evt.target;

      do {
        if (targetElement === finishingPositionIcon) return;
        targetElement = targetElement.parentNode;
      } while (targetElement);

      if (this.isFinishPositionPopupOpen)
        this.isFinishPositionPopupOpen = false;
    },
    onTeamDetailsTableScrolled(event) {
      if (this.isFinishPositionPopupOpen)
        this.isFinishPositionPopupOpen = false;
      this.scrollLeft = -event.target.scrollLeft;
    },
    onDateOrderingToggled() {
      this.setRaceCardDateToggleAscending(!this.raceCardDateToggleAscending);
      this.toggleRaceCardPreviousRunData();
    },
    toggleRaceCardPreviousRunData() {
      this.setDateOrderingIconState();
      this.setVisiblePreviousRaceResults();
    },
    toggleFinishPositionPopUp(event) {},
    setVisiblePreviousRaceResults() {
      const raceResultSet = this.raceCardDateToggleAscending
        ? this.runner.horse.previousRaceResults
        : this.runner.horse.previousRaceResultsOther;
      this.visiblePreviousRaceResults = this.areRaceResultsExpanded
        ? raceResultSet
        : this.raceCardDateToggleAscending
        ? raceResultSet.slice(0, 7)
        : raceResultSet.slice(-7);
    },
    onFormGridOpened(position) {
      this.openFormGridCallback(position);
      this.isFinishPositionPopupOpen = false;
    },
    onHorseNameClicked(horseNameId) {
      this.setSelectedHorse({});
    },
    onJockeyNameClicked(jockeyNameId) {
      this.setSelectedJockey({});
    },
    onTrainerNameClicked(trainerNameId) {
      this.setSelectedTrainer({});
    },
    onBreederNameClicked(breederNameId) {
      this.setSelectedBreeder({});
    },
    openFormGrid(id, position) {
      this.isFormGridOpen = true;
      this.openFormGridCallback(id, position);
    },
    toggleExtraRaceResults() {
      const rotationDeg = this.areRaceResultsExpanded ? "0" : "180";
      document.querySelector(
        `#extra-rows-down-arrow-${this.index}`,
      ).style.transform = "rotate(" + rotationDeg + "deg)";
      this.areRaceResultsExpanded = !this.areRaceResultsExpanded;
      this.setVisiblePreviousRaceResults();
    },
    onHollywoodOddsClicked(url) {
      window.open(url, "_blank");
    },
    setDateOrderingIconState() {
      const rotationDeg = this.raceCardDateToggleAscending ? "0" : "180";
      document.querySelector(
        `#date-ordering-icon-${this.index}`,
      ).style.transform = "rotate(" + rotationDeg + "deg)";
    },
    ...mapMutations([
      "setSelectedHorse",
      "setSelectedTrainer",
      "setSelectedJockey",
      "setSelectedBreeder",
      "setRaceCardDateToggleAscending",
    ]),
  },
  watch: {
    selectedRace: function (newVal, oldVal) {
      this.setJockeySilkPath();
    },
    runner: function (newVal, oldVal) {
      this.setVisiblePreviousRaceResults();
    },
    raceCardDateToggleAscending: function (newVal, oldVal) {
      if (oldVal === this.raceCardDateToggleAscending) return;
      this.toggleRaceCardPreviousRunData();
    },
  },
  mounted: function () {
    this.setTableState();
    const { raceTrackAssetId } = this.selectedRaceCard.raceCardSummary;
    const showRaceCourseLogoTitleIds = [2, 6, 7, 8, 10, 11];
    this.showHorseSaddleCloths =
      showRaceCourseLogoTitleIds.indexOf(parseInt(raceTrackAssetId, 10)) > -1;

    this.visiblePreviousRaceResults = this.raceCardDateToggleAscending
      ? this.runner.horse.previousRaceResults.slice(0, 7)
      : this.runner.horse.previousRaceResultsOther.slice(0, 7);
    this.setDateOrderingIconState();
    document.querySelectorAll("#team-details-table").forEach((element) => {
      element.addEventListener(
        "scroll",
        this.onTeamDetailsTableScrolled.bind(this),
      );
    });
    window.onresize = () => {
      this.setTableState();
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#team-details-table {
  margin-bottom: 0 !important;
}

#team-details-table th {
  text-align: center;
  vertical-align: middle;
}

.toggle-arrow {
  height: 6px;
  width: 6px;
}

.jockey-weight-apprentice-claim td {
  height: auto !important;
}

.jockey-apprentice-claim {
  font-size: 0.8rem;
  font-weight: bold;
}

.race-comment {
  border: 1px solid #000000;
}

thead {
  background-color: #000000 !important;
  line-height: 0.7;
}

.table-responsive {
  border: 1px solid #7c7c7c !important;
  margin-bottom: 0.5rem !important;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
}

.horse-name {
  color: #000000;
  font-size: 0.8rem;
}

.horse-name-number {
  font-size: 1.25rem !important;
}

.horse-details,
.jockey-trainer-career {
  font-size: 0.65rem;
  line-height: 0.9rem;
}

.horse-race-details {
  border: solid 2px black;
  background-color: #dcdcdc;
  padding: 0.84rem 0;
  border-radius: 5px;
}

.horse-race-details td {
  height: 2.2rem;
  padding: 0 !important;
  vertical-align: middle;
  border: none !important;
}

.horse-race-details span {
  font-size: 0.8rem;
}

.horse-race-details table {
  table-layout: fixed;
  border-style: hidden !important;
  margin-bottom: 0 !important;
}

.num-circle-td {
  display: flex;
  justify-content: center;
  align-items: center;
}

.numberCircle {
  display: table;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  font-size: 500%;
  margin: 5%;
  background: #000000;
}

.jockey-silks {
  width: 5rem;
}

.numberCircle span {
  display: table-cell;
  vertical-align: middle;
  font-size: 0.9rem;
}

.team-details {
  line-height: 1.1rem;
}

.jockey-trainer-name {
  font-size: 0.8rem;
}

.horse-career-wrapper {
  border: solid 2px black;
  border-radius: 4px;
  line-height: 1rem;
  padding: 0.2rem 0;
}

.horse-career-wrapper table {
  width: 100%;
  text-align: center;
}

.horse-career-wrapper td {
  font-size: 0.55rem;
  text-align: right;
  line-height: 0.7rem;
}

.badge {
  background-color: #5e2a95;
  padding: 0.4rem 1rem;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
}

.badge-disabled-betting {
  background-color: #dcdcdc;
}

.table-responsive tr {
  text-align: center;
}

tbody {
  overflow-y: scroll;
}

.team-details-table {
  margin-top: 0.6rem;
}

table td {
  vertical-align: middle;
}

td {
  white-space: nowrap;
  line-height: 0.9;
}

.finishing-position-icon {
  width: 1.2rem;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.35);
  border-radius: 50%;
}

.finishing-position-icon:hover {
  box-shadow: 2px 3px 8px 0 rgba(0, 0, 0, 0.8);
  cursor: pointer;
  position: relative;
}

.race-draw {
  font-size: 1.05rem !important;
  font-weight: bolder;
}

.highlighted-table-cell {
  background-color: #f2f2f2;
}

.extra-rows-toggle-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: #000000;
  padding: 0 !important;
  border: 1px solid #7c7c7c !important;
  margin-bottom: 0.5rem !important;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
}

.extra-rows-down-arrow {
  height: 35px;
  font-weight: bolder;
}

.scratched-runner {
  background-color: red;
  color: #ffffff;
}

.jockey-trainer-name-scratched {
  color: red;
  border-top: 2px red solid;
  border-bottom: 2px red solid;
  font-size: 1.3rem;
  font-weight: bold;
}

.red-text {
  color: red !important;
}

.hollywood-odds {
  text-align: center;
}

.saddle-cloths {
  width: 45px;
}

@media (min-width: 576px) {
  .toggle-arrow {
    height: 12px;
    width: 12px;
  }

  .horse-career-wrapper td {
    font-size: 0.8rem;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  .jockey-apprentice-claim {
    font-size: 0.8rem;
  }

  .jockey-trainer-name {
    font-size: 1.1rem;
  }

  .numberCircle {
    height: 22px;
    width: 22px;
  }

  .horse-name {
    font-size: 1.6rem;
    font-weight: bolder;
  }

  .horse-name-number {
    font-size: 1.95rem !important;
  }

  .finishing-position-icon {
    width: 1.5rem;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  .jockey-trainer-name {
    font-size: 1.1rem;
  }

  .horse-name {
    font-size: 1.6rem;
    font-weight: bolder;
  }

  .horse-name-number {
    font-size: 1.95rem !important;
  }

  .finishing-position-icon {
    width: 1.5rem;
  }
}

@media (min-width: 1200px) {
  .table th {
    font-size: 1rem;
  }

  td {
    padding: 0.25rem !important;
  }

  .horse-name {
    font-size: 1.2rem;
    font-weight: bolder;
  }

  .horse-name-number {
    font-size: 1.95rem !important;
  }

  .horse-details {
    margin-bottom: 0.1rem;
  }

  .horse-details,
  .jockey-trainer-career {
    font-size: 0.9rem;
    line-height: 1.15rem;
  }

  .jockey-silks {
    width: 7rem;
  }

  .badge-secondary {
    font-size: 1.3rem;
  }

  .jockey-trainer-name {
    font-size: 1.2rem;
    line-height: 1.6rem;
    text-align: center;
  }

  .horse-race-details {
    padding: 1rem 0.4rem;
  }

  .horse-race-details span {
    font-size: 0.8rem;
  }

  .horse-career-wrapper td {
    padding: 0 1rem;
    font-size: 1.1rem;
    line-height: 1rem;
  }

  .finishing-position-icon {
    margin: 2px;
    width: 1.7rem;
  }

  .horse-race-details td {
    height: 4rem;
  }

  .race-draw {
    font-size: 1.3rem !important;
  }

  .numberCircle span {
    font-size: 1rem !important;
  }

  .horse-race-details span {
    font-size: 1rem;
  }

  .race-draw {
    font-size: 1.3rem !important;
  }
}

@media (min-width: 1660px) {
  .horse-name {
    font-size: 1.6rem;
  }
}
</style>
